import { FC } from 'react'
import { useField } from 'react-final-form'

import TextField, {
  Props as TextFieldProps,
} from '~/form/components/molecules/TextField'

type Props = Pick<TextFieldProps, 'isConfirm' | 'required'>

const NAME = 'companyName'

const CompanyNameField: FC<Props> = (props) => {
  const {
    input: { value },
  } = useField(NAME)

  if (props.isConfirm && !value) return null

  return (
    <TextField
      name={NAME}
      ariaLabel='企業名・組織名・屋号'
      label='企業名・組織名・屋号'
      {...props}
    />
  )
}

CompanyNameField.displayName = 'companyName'

export default CompanyNameField
